export default __webpack_public_path__ + "static/media/author-Ishan.png.webp";